<template>
  <v-navigation-drawer dark app v-model="show">
    <v-col cols="12">
      <v-row align="center" no-gutters>
        <v-avatar small color="white" class="mr-2"></v-avatar>
        <v-col cols="auto" shirnk class="d-flex flex-column white--text">
          <span :style="{ fontSize: '18px' }">Username</span>
          <span :style="{ fontSize: '16px' }">role</span>
        </v-col>
      </v-row>
    </v-col>
    <v-divider class="mb-1"></v-divider>
    <v-list dense class="ma-0 pa-0">
      <v-list-item
        v-for="item in items"
        :key="item.title"
        links
        :to="item.route"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title :style="{ fontSize: '16px' }">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="(item, idx) in system_modules"
        :key="idx"
        links
        :to="`/Workflow/${item.systemCode}`"
      >
        <v-list-item-avatar size="30px">
          <v-img :src="item.iconUrl"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title :style="{ fontSize: '16px' }">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn block @click="logout"> Logout </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      items: [
        {
          route: "/Questionnaire/",
          title: "Questionnaire",
          icon: "mdi-file-question-outline",
        },
        {
          route: "/Content",
          title: "Content",
          icon: "mdi-select-group",
        },
        {
          route: "/Hierarchy",
          title: "Hierarchies",
          icon: "mdi-transit-connection",
        },
        {
          route: "/Group",
          title: "Groups",
          icon: "mdi-select-group",
        },
      ],
      system_modules: [],
    };
  },
  mounted() {
    this.getModules();
  },
  methods: {
    toggleNavigationDrawer() {
      this.show = !this.show;
    },
    routeToItem(item) {
      let self = this;
      self.$router.push(item.route);
    },
    logout() {
      let self = this;
      self.$router.push("/login");
    },
    getModules() {
      setTimeout(() => {
        this.system_modules = [];
        let modules = window._SystemModules;

        for (var module in modules) {
          this.system_modules.push(modules[module]);
        }
      }, 1000);
    },
  },
};
</script>